module.exports = __webpack_public_path__ + "static/media/seaborn.a3deb6c4.jpeg";